import { createResource } from 'react-resource-router';

import { MergeQueue } from 'src/components/pipelines/models/MergeQueue';
import { fetchData } from 'src/components/pipelines/resources/utils';
import { SentryPipelinesTeam } from 'src/components/pipelines/utils/sentry';

import { getMergeQueuesUrl as getMergeQueuesApiUrl } from './constants';
import { MergeQueuesResourceResponse, MergeQueueResponse } from './types';
import { MERGE_QUEUES_PAGE_LENGTH } from './utils';

const getMergeQueuesUrl = (
  repositoryOwner: string,
  repositorySlug: string,
  page: string = '1',
  pagelen: string = MERGE_QUEUES_PAGE_LENGTH.toString()
) => {
  return getMergeQueuesApiUrl(repositoryOwner, repositorySlug, {
    page,
    pagelen,
  });
};

export const mergeQueuesRouteResource =
  createResource<MergeQueuesResourceResponse>({
    type: 'mergeQueues',
    getKey: ({ match, query }) => {
      return getMergeQueuesUrl(
        match.params.repositoryOwner!,
        match.params.repositorySlug!,
        query.page
      );
    },
    maxAge: 60000,
    getData: async ({ match, query }) => {
      const apiBaseUrl = getMergeQueuesUrl(
        match.params.repositoryOwner!,
        match.params.repositorySlug!,
        query.page
      );

      const mergeQueues = await fetchData(
        apiBaseUrl,
        'merge_queues_resource_exception',
        {},
        'json',
        SentryPipelinesTeam.Mangalyaan
      );

      return {
        page: mergeQueues.page,
        pagelen: mergeQueues.pagelen,
        size: mergeQueues.size,
        values: mergeQueues.values.map(
          (mergeQueue: MergeQueueResponse) => new MergeQueue(mergeQueue)
        ),
      };
    },
  });
